import { CATEGORY_BY_SLUG } from "../data/categories";
import { campaignPath } from "./campaign";

const API = process.env.REACT_APP_BACKEND_URL;
const DESCRIPTION_MAX = 155;

const firstNameOf = (c) => ((c?.student_name || c?.full_name || "").trim().split(/\s+/)[0]) || "A student";

/** First sentence(s) of the story, cut on a word boundary at ~155 chars. */
const storyLead = (story) => {
  const flat = (story || "").replace(/\s+/g, " ").trim();
  if (!flat) return "";
  if (flat.length <= DESCRIPTION_MAX) return flat;
  const cut = flat.slice(0, DESCRIPTION_MAX);
  return `${cut.slice(0, Math.max(cut.lastIndexOf(" "), 80)).replace(/[,;:\s]+$/, "")}…`;
};

/**
 * Per-campaign SEO props for `<SEO />` on live/closed campaign pages:
 * student's first name in the title, the story lead as the description,
 * the cover photo as og:image, canonical = the vanity link when one exists.
 */
export const campaignSeo = (c) => {
  const first = firstNameOf(c);
  const category = CATEGORY_BY_SLUG[c?.category]?.label;
  const goal = c?.goal_cents ? `$${Math.round(c.goal_cents / 100).toLocaleString()}` : null;
  const title = c?.title
    ? `${c.title} — ${first}'s campaign · My Rich Aunt`
    : `${first}'s campaign · My Rich Aunt`;
  const fallback = [
    `${first}${c?.school ? ` at ${c.school}` : ""} is raising${goal ? ` ${goal}` : ""}${category ? ` for ${category.toLowerCase()}` : ""} through My Rich Aunt,`,
    "a 501(c)(3) that awards direct grants to verified college students.",
  ].join(" ");
  const description = storyLead(c?.story) || (c?.headline || "").trim() || fallback;
  const image = c?.cover_file_id ? `${API}/api/files/${c.cover_file_id}` : "/og-image.jpg";
  return {
    title,
    description,
    path: campaignPath(c),
    image,
    imageAlt: c?.cover_file_id ? (c.title || `${first}'s campaign`) : undefined,
  };
};
